module.exports = __webpack_public_path__ + "media/customizations/bigsky/logo-c8739b1cbf8911e838e8d25e63747659.png";